var AS2StageAdapter = (function () {
    function AS2StageAdapter() {
    }
    return AS2StageAdapter;
}());
export { AS2StageAdapter };
// this does nothing really, just to catch usage in scripts
AS2StageAdapter.showMenu = true;



// WEBPACK FOOTER //
// ../dist/lib/adapters/AS2StageAdapter.js